"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgLogoutCtl = /** @class */ (function (_super) {
    __extends(DlgLogoutCtl, _super);
    function DlgLogoutCtl() {
        return _super.call(this, true) || this;
    }
    DlgLogoutCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            visible: false
        };
    };
    DlgLogoutCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgLogoutCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgLogoutCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgLogoutCtl.prototype, "OnYes", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgLogoutCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    return DlgLogoutCtl;
}(BaseController_1.BaseController));
exports.DlgLogoutCtl = DlgLogoutCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgLogoutCtl.ts
// module id = 890
// module chunks = 0